export const FARM_SELECTOR_FARM_AND_CLIENTS_ALLOWED_PAGES = ['/dashboard/overview', '/installation']
export const FARM_SELECTOR_FARM_AND_CLIENTS_EXCLUDED_PATHS = ['/properties/tariffs']
export const FARM_SELECTOR_ONLY_FARM_ALLOWED_PAGES = ['/dashboard/documents', '/properties/grid-and-system-protection-configuration']

export const FARM_SELECTOR_SETTINGS_EXCLUDED_PATH = '/properties'

export const SETTING_RESTRICTED_TO_SERVER_TRANSLATION_KEY = 'systemSettings.access.only-farm'
export const ACTION_RESTRICTED_TO_SERVER_TRANSLATION_KEY = 'systemSettings.access.only-farm-action'

export const SETTING_RESTRICTED_TO_CLIENT_TRANSLATION_KEY = 'systemSettings.access.only-client'
export const ACTION_RESTRICTED_TO_CLIENT_TRANSLATION_KEY = 'systemSettings.access.only-client-action'

export const SETTINGS_DISABLED_SWITCHING_ACTUATOR_TRANSLATION_KEY = 'systemSettings.smartHome.disabledSwitchingActuator'
